import './modules/register-service-worker';
import { branchBar } from '@crasman/branch-bar';

import Accordion from './modules/accordion';
import Nav from './modules/nav';
import TyreSizes from './modules/tyreSizes';
import Toggle from './modules/toggle';

// See https://www.npmjs.com/package/@crasman/branch-bar for settings
branchBar.init();

//Accordions
const accordions = document.querySelectorAll('.js-accordion');
accordions.forEach(el => {
  new Accordion(el, {
    allowMultipleOpen: el.getAttribute('data-allow-multiple-open') === 'true'
  });
});

//Nav
const nav = document.querySelectorAll('.js-nav');
nav.forEach(el => {
  new Nav(el, {
  });
});

//Toggles
const toggles = document.querySelectorAll('.js-toggle');
toggles.forEach(el => {
  new Toggle(el);
});

//Tyre sizes
const tyreSizes = document.querySelectorAll('.js-tyre-sizes');
tyreSizes.forEach(el => {
  new TyreSizes(el, {
  });
});
